/**
 *
 * Asynchronously loads the component for Com002
 * Author: Truongtx
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
